import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxPopupModule,
  DxRadioGroupModule,
  DxTextAreaModule,
  DxButtonModule,
  DxToolbarModule,
} from 'devextreme-angular';
import { SharedModule } from '../../../../shared/shared.module';
import { AssignmentCompletionDto, AssignmentCompletionOption } from '../../../../shared/generated/backend';
import { ValueChangedEvent } from 'devextreme/ui/radio_group_types';

@Component({
  selector: 'app-assignment-status-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxTextAreaModule,
    DxButtonModule,
    DxToolbarModule,
    SharedModule,
  ],
  templateUrl: './assignment-status-dialog.component.html',
  styleUrl: './assignment-status-dialog.component.scss',
})
export class AssignmentStatusDialogComponent {
  visible = input(false);
  assignmentCompleteData = input<AssignmentCompletionDto>({
    ProjectLoadunitId: -1,
    Completed: true,
    CompletionOption: AssignmentCompletionOption.Good,
    Subject: '',
    Comment: '',
  });
  assignmentCompleteOptions = input<{ display: string; value: AssignmentCompletionOption }[]>([]);
  visibleChange = output<boolean>();
  assignmentCompleteDataChange = output<AssignmentCompletionDto>();
  sendStatusChange = output<void>();
  hiding = output<void>();

  closeDialog(): void {
    this.visibleChange.emit(false);
  }

  onCommentChange(value: string): void {
    this.assignmentCompleteDataChange.emit({
      ...this.assignmentCompleteData(),
      Comment: value,
    });
  }

  onCompletionOptionChange(value: AssignmentCompletionOption): void {
    this.assignmentCompleteDataChange.emit({
      ...this.assignmentCompleteData(),
      CompletionOption: value,
    });
  }

  radioGroupValueChanged(e: ValueChangedEvent): void {
    const selectedItem = this.assignmentCompleteOptions().find(opt => opt.value === e.value);
    if (selectedItem) {
      this.assignmentCompleteDataChange.emit({
        ...this.assignmentCompleteData(),
        Subject: selectedItem.display,
        CompletionOption: e.value,
      });
    }
  }

  handleSendStatusChange(): void {
    this.sendStatusChange.emit();
  }

  handlePopupHide(): void {
    this.hiding.emit();
  }
}
